{
  "APP_NAME": "SGS",
  "About": "A propos",
  "Hello world !": "Bonjour le monde !",
  "Home": "Accueil",
  "Logged in as": "Connecté en tant que",
  "Login": "Connexion",
  "Logout": "Déconnexion",
  "Password": "Mot de passe",
  "Password is required": "Mot de passe requis",
  "Username": "Identifiant",
  "Username is required": "Identifiant requis",
  "Username or password incorrect.": "Identifiant ou mot de passe incorrect.",
  "Remember me": "Rester connecté",
  "Version": "Version"
}
